// TargetMarginsResetter.tsx
import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import {
  selectOrderPayPackagesInteraction,
  selectTargetMargins,
  selectTmVersion,
} from '@AMIEWEB/Order/Store/Order.selectors';
import { FormNames } from '@AMIEWEB/Common/SubmissionPreference/Common/helper';
import { OrderPayPackagesAction } from '@AMIEWEB/Order/Store/types';

export const TargetMarginsResetter: React.FC = () => {
  const targetMarginsSelector = useSelector(selectTargetMargins);
  const orderPayPackagesInteraction = useSelector(selectOrderPayPackagesInteraction);
  const tmVersion = useSelector(selectTmVersion);
  const isResetActionTriggered = orderPayPackagesInteraction?.action === OrderPayPackagesAction.TARGET_MARGIN_RESET;

  const { resetField, setValue } = useFormContext();

  // useLayoutEffect so it fires synchronously after commit,
  // and before the browser paints, avoiding flicker and racey unmounts.
  useLayoutEffect(() => {
    if (isResetActionTriggered) {
      setValue(FormNames.TargetMargins, _.cloneDeep(targetMarginsSelector));
    } else {
      resetField(FormNames.TargetMargins, { defaultValue: _.cloneDeep(targetMarginsSelector) });
    }
  }, [tmVersion, targetMarginsSelector]);

  return null; // purely side-effectful
};
